import globalIP from '@/GlobelIP';
import React, { useEffect, useState } from 'react';
import { FlexboxGrid, SelectPicker, Stack, Toggle } from 'rsuite';

const Modules = () => {
  const [userdata, setUserData] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);

  useEffect(() => {
    fetchDatac();
  }, []);
  const fetchDatac = async () => {
    try {
      const response = await fetch(`${globalIP}/api/user-details?populate=*`);
      const json = await response.json();
      const processedData = json.data.map(item => ({
        label: item.attributes.Full_Name,
        value: item.id
      }));
      setUserData(processedData);
    } catch (error) {
      console.error('Error fetching category data:', error);
    }
  };
  const [permissions, setPermissions] = useState({
    MProduct: false,
    MCatalogue: false,
    MCollection: false,
    MQuotation: false,
    MEmarketing: false,
    MSpaceV: false,
    MFair: false,
    MEnquiry: false,
    MGreeting: false,
    MBuyer: false,
    PMaster: false
  });

  // Fetch data from API on component mount
  useEffect(() => {
    fetch(`http://192.168.1.46:1338/api/user-details/${selectedUser}`)
      .then(res => res.json())
      .then(data => {
        if (data?.data) {
          setPermissions({
            MProduct: data.data.attributes.MProduct,
            MCatalogue: data.data.attributes.MCatalogue,
            MCollection: data.data.attributes.MCollection,
            MQuotation: data.data.attributes.MQuotation,
            MEmarketing: data.data.attributes.MEmarketing,
            MSpaceV: data.data.attributes.MSpaceV,
            MFair: data.data.attributes.MFair,
            MEnquiry: data.data.attributes.MEnquiry,
            MGreeting: data.data.attributes.MGreeting,
            MBuyer: data.data.attributes.MBuyer,
            PMaster: data.data.attributes.PMaster
          });
        }
      })
      .catch(err => console.error('Error fetching data:', err));
  }, [selectedUser]);

  // Function to handle toggle change
  const handleToggleChange = key => {
    const updatedPermissions = { ...permissions, [key]: !permissions[key] };
    setPermissions(updatedPermissions);

    // Send updated data to API
    fetch(`http://192.168.1.46:1338/api/user-details/${selectedUser}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        data: updatedPermissions
      })
    })
      .then(res => res.json())
      .then(data => console.log('Updated successfully:', data))
      .catch(err => console.error('Error updating:', err));
  };
  return (
    <>
      <SelectPicker
        data={userdata}
        value={selectedUser}
        onChange={value => setSelectedUser(value)}
        placeholder="Select a user"
        style={{ marginBottom: '10px' }}
      />
      <FlexboxGrid justify="start">
        {[
          { key: 'MProduct', label: 'Manage Product' },
          { key: 'MCatalogue', label: 'Manage Catalogue' },
          { key: 'MCollection', label: 'Manage Collection' },
          { key: 'MQuotation', label: 'Manage Quotation' },
          { key: 'MEmarketing', label: 'Manage E-marketing' },
          { key: 'MSpaceV', label: 'Space Visual' },
          { key: 'MFair', label: 'Manage Fair' },
          { key: 'MEnquiry', label: 'Manage E-tracker' },
          { key: 'MGreeting', label: 'Manage Greeting' },
          { key: 'MBuyer', label: 'Manage Buyer' },
          { key: 'PMaster', label: 'Product Masters' }
        ].map(item => (
          <FlexboxGrid.Item key={item.key} colspan={6}>
            <div
              style={{
                padding: '8px',
                width: '200px',
                background: 'aliceblue',
                borderRadius: '6px',
                margin: '4px'
              }}
            >
              <Stack justifyContent="space-between">
                <Toggle
                  size="sm"
                  checked={permissions[item.key]}
                  onChange={() => handleToggleChange(item.key)}
                />
                <p>{item.label}</p>
              </Stack>
            </div>
          </FlexboxGrid.Item>
        ))}
      </FlexboxGrid>
    </>
  );
};

export default Modules;
